import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    list: {
        paddingBottom: Theme.BU * 2,
        flex: 1
    },
    noDataText: {
        marginTop: '20%',
        width: '100%'
    }
};

export default StyleSheet.create(baseStyles);
